export default {
  BACKEND_ROOT_URL: process.env.REACT_APP_BACKEND_URL,
};
